// @ts-nocheck
import React, { useEffect, useState } from 'react';

import Stats from './components/Stats';
import { getGeneralStats } from '../../actions/userActions';
import RequestStats from './components/RequestStats';
import CompanyStats from './components/CompanyStats';
import Loading from '../common/Loading';
import { hasAnyPermission, hasPermission, userIs } from '../auth/authUtils';
import permissionTypes from '../../constants/permissionTypes';
import StatsOverTime from '../common/StatsOverTime';
import { DateForFilter } from '../../util/formatter';
import userTypes from '../../constants/userTypes';
import ConnectedUsers from './components/ConnectedUsers';
import { statsModes } from '../../hooks/useAggregateStatsData';
import { useNavigate } from 'react-router-dom';
import { getStatsByDay } from '../../api/requestApi';
import { useAppSelector } from '../../hooks';

function HomeAdvanced() {
  const currentUser = useAppSelector((state) => state.auth);

  const [stats, setStats] = useState<any>();
  const navigate = useNavigate();
  const [reload] = useState<any>();

  useEffect(() => {
    if (!stats) {
      getGeneralStats()
        .then((d) => {
          setStats(d);
        })
        .catch(() => { });
    }
  }, [currentUser, stats]);

  const userHasPermissionToHeatmap = () => {
    return (
      hasAnyPermission(currentUser, [
        permissionTypes.MANAGE_KEYS,
        permissionTypes.VIEW_REPORTS,
      ]) || userIs(currentUser, userTypes.APPROVER)
    );
  };

  const heatmapControl = () => (
    <div className="col-12">
      <StatsOverTime
        getData={() => getStatsByDay()}
        onClick={(value: any) => {
          if (value) {
            const date = DateForFilter(value.date);
            const destination = `/requests/all?f_requestedDateFrom=${date}&f_requestedDateTo=${date}`;
            navigate(destination);
          }
        }}
        mode={statsModes.ALL}
      />
    </div>
  );

  return stats ? (
    <>
      <Stats id={currentUser?.id} stats={stats} currentUser={currentUser} />

      {userHasPermissionToHeatmap() && heatmapControl()}

      <div className="row equal-height">
        <div className="col-12 col-lg-6">
          <RequestStats
            openRequests={stats.allOpenRequests}
            openRequestsValue={stats.allOpenRequestsValue}
            openRequestsSLABreached={stats.overSLA}
            openRequestsSLABreachedValue={stats.overSLAValue}
            requestsNeedingKeys={stats.requestsNeedingKeys}
            requestsNeedingKeysValue={stats.requestsNeedingKeysValue}
            keysOrdered={stats.keysOrdered}
            keysOrderedValue={stats.keysOrderedValue}
            requestsYouCanAuthorise={stats.requestsYouCanAuthorise}
            requestsYouCanAuthoriseValue={stats.requestsYouCanAuthoriseValue}
          />
        </div>

        {hasPermission(currentUser, permissionTypes.MANAGE_COMPANIES) && (
          <div className="col-12 col-lg-6">
            <CompanyStats reload={reload} />
          </div>
        )}
      </div>
      <div className="row equal-height">
        <div className="col-12">
          <ConnectedUsers />
        </div>
      </div>
    </>
  ) : (
    <Loading></Loading>
  );
}

export default HomeAdvanced;
